<template>
    <el-drawer
        title="一起看现场数据"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading"> 
			<div class="page-group-title"><span>数据详情</span></div>
			<div v-if="data" class="group">                    
                    <table class="info-table MT20" width="100%">
                        <tr>
                            <th>看现场列表pv </th>
                            <td>{{data.pv}}</td>
                            <th>看现场列表uv </th>
                            <td>{{data.uv}}</td>
                        </tr>
                        <tr>
                            <th>邀请发布人数 </th>
                            <td>{{data.declareNum}}</td>
                            <th>邀请TA按钮点击人数</th>
                            <td>{{data.invitedButtonNum}}</td>
                        </tr>
                        <tr>
                            <th>成功发送邀请人数</th>
                            <td>{{data.invitedNum}}</td>
                            <th>点击解锁邀请人数</th>
                            <td>{{data.invitedAnswerNum}}</td>
                        </tr>
                        <tr>
                            <th>演出详情入口:点击次数</th>
                            <td>{{data.activityDetailPv}}</td>
                            <th>演出详情入口:点击人数</th>
                            <td>{{data.activityDetailUv}}</td>
                        </tr>
                        <tr>
                            <th>购票成功入口:点击次数 </th>
                            <td>{{data.buySuccessPv}}</td>
                            <th>购票成功入口:点击人数 </th>
                            <td>{{data.buySuccessUv}}</td>
                        </tr>
						<tr>
						    <th>订单详情入口:点击次数 </th>
						    <td>{{data.orderDetailPv}}</td>
						    <th>订单详情入口:点击人数 </th>
						    <td>{{data.orderDetailUv}}</td>
						</tr>
						<tr>
						    <th>票夹入口:点击次数 </th>
						    <td>{{data.ticketWalletPv}}</td>
						    <th>票夹入口:点击人数 </th>
						    <td>{{data.ticketWalletUv}}</td>
						</tr>
                    </table>
                </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关 闭</el-button>			
        </div>
    </el-drawer>
</template>

<script>

export default {
    components:{},
	
    data(){
        return{
            drawerShow: false,
            dataLoading:false,           
            id:'',
            data: null,
			
        }
    },
    methods:{
        close(){            
            this.data = null;
            this.drawerShow = false;
        },
        show(id){			
			this.drawerShow = true;
			this.id = id
			this.getData()
        },
        //获取详情
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/watchTogether/statistics',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result || null
                        
                    } else {
                        this.$message.error(msg || "获取详情失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取详情失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		
		
    }
}
</script>

<style lang="scss" scoped>
.info-table{
    th{
        min-width: 100px;
        text-align: right;
        white-space: nowrap;
    }
    td{
        min-width: 150px;
    }
}

.ML5{
	margin-left: 5px;
}
</style>